import cx from "classnames"
import { useMemo, useRef } from "react";
import { useAutoFitHtml } from "./hooks/useAutoFitHtml";
import "src/shared/components/data-display/rich-text-editor/preview/RichTextPreview.css"

interface AvisoProps {
    value: string
    className?: string
}

export function Aviso({ value = "", className = "" }: AvisoProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);

    const html = useMemo(()=>{
        return value
            .replace(/\*\*\*--(.*?)--\*\*\*/g, "<b><i><u>$1</u></i></b>")
            .replace(/\*\*\*(.*?)\*\*\*/g, "<b><i>$1</i></b>")
            .replace(/\*\*--(.*?)--\*\*/g, "<b><u>$1</u></b>")
            .replace(/\*--(.*?)--\*/g, "<i><u>$1</u></i>")
            .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
            .replace(/\*(.*?)\*/g, "<i>$1</i>")
            .replace(/--(.*?)--/g, "<u>$1</u>")
            .replace(/<br>/g, "<br />");
    }, [value])

    
    useAutoFitHtml({
        containerRef,
        contentRef,
        html,
        minFontSize: 12,
        maxFontSize: 48,
    })

    return (
        <div className={cx("disp__message-slide", className)}>
            <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center",  alignItems: "center", flexDirection: "column" }} ref={containerRef}>
                <div
                    ref={contentRef}
                    className={cx("richtext-preview", "disp__aviso")}
                    dangerouslySetInnerHTML={{
                        __html: html,
                    }}
                    style={{
                        lineHeight: 1.1,
                        wordBreak: "break-word",
                        textAlign:  "center"
                    }}
                />
            </div>
        </div>
    )
}